import { Component, computed, inject, input } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faInfinity } from "@fortawesome/free-solid-svg-icons";
import { UserRoles } from "src/app/core/models/user.model";
import { SubscriptionSummary } from "src/app/core/services/assign-diagnostic.service";
import { SessionStorageService } from "src/app/core/services/session-storage.service";

@Component({
  selector: 'wf-subscription-summary',
  standalone: true,
  imports: [
    FontAwesomeModule
  ],
  styleUrl: 'subscription-summary.component.css',
  template: `
    <div class="summary">
      <h4> {{ subscriptionsType() === 'diagnostic' ? 'Diagnostic' : 'System' }} </h4>
        @let unassignedChangeText = editTotal() ? (
         '(' + ((editTotal() < 0) ? ('+' + editTotal() * -1) : editTotal() * -1) + ')'
        ) : '';
        @let teacherChangeText = editTotal() ? (
          '(' + ((editTotal() < 0) ? editTotal() : ('+' + editTotal())) + ')'
        ) : '';
        <div class="summary-row">
          <span class="summary-number summary-number-unassigned">{{ summary().unassigned - editTotal() }}</span>
          <span class="summary-label"> {{ unassignedChangeText }} Unassigned</span>
        </div>
        <div class="summary-row">
          <span class="summary-number summary-number-teacher">{{ summary().teacher + editTotal() }}</span>
          <span class="summary-label"> {{ teacherChangeText }} Granted to teachers</span>
        </div>
        <div class="summary-row">
          <span class="summary-number summary-number-student">{{ summary().student }}</span>
          <span class="summary-label">Assigned to students who haven't started</span>
        </div>
        <div class="summary-row">
          <span class="summary-number summary-number-consumed">{{ summary().consumed }}</span>
          <span class="summary-label">Consumed</span>
        </div>
        <span class="summary-row-border"></span>
        <div class="summary-row">
          <span class="summary-number">{{ summary().unassigned + summary().teacher + summary().student + summary().consumed }}</span>
          <span class="summary-label bold">Total Subscriptions</span>
        </div>
    </div>
  `
})
export class SubscriptionSummaryComponent {
  readonly subscriptionsType = input.required<"diagnostic" | "system">();
  readonly summary = input.required<SubscriptionSummary>();
  readonly editTotal = input(0);

  protected readonly infinityIcon = faInfinity;
}
